import {
  getZClousureByDate,
  getAllZClousureByRangeOfDates
} from "@/collections/zClousures";

const state = { zClosuresHistory: [] };

const mutations = {
  setZclosuresHistory(state, val) {
    state.zClosuresHistory = val;
  }
};

const actions = {
  async zClosuresHistoryByRangeOfDate({ commit }, rangeOfDates) {
    try {
      if (rangeOfDates.start.getTime() === rangeOfDates.end.getTime()) {
        let result = await getZClousureByDate(rangeOfDates.start);
        commit("setZclosuresHistory", result);
      } else {
        let result = await getAllZClousureByRangeOfDates(
          rangeOfDates.start,
          rangeOfDates.end
        );
        commit("setZclosuresHistory", result);
      }
    } catch (error) {
      this.setlogError(
        "get_all_zClousure_by_range_of_dates/zClousure_by_date",
        "Obtained error message in zClosuresHistoryByRangeOfDate()",
        error.stack,
        this.$options.name
      );
    }
  }
};

const getters = {};

export default {
  state,
  mutations,
  actions,
  getters
};
